import { render, staticRenderFns } from "./CatalogSupplierModal.vue?vue&type=template&id=df613ce4"
import script from "./CatalogSupplierModal.vue?vue&type=script&lang=js"
export * from "./CatalogSupplierModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports